export default __webpack_public_path__ + "static/media/excecao_full_red.88a921e5.svg";